import React, { useEffect, useState } from "react";

const IntegrationList = ({ onEdit }) => {
    const [integrations, setIntegrations] = useState([]);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    useEffect(() => {
        fetch(`${apiUrl}/integrations`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch integrations");
                }
                return response.json();
            })
            .then((data) => setIntegrations(data))
            .catch((error) => {
                console.error("Error fetching integrations:", error);
                setError("Failed to load integrations. Please try again.");
            });
    }, []);

    if (error) {
        return <p className="text-danger">{error}</p>;
    }

    return (
        <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Url</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {integrations.map((integration) => (
                    <tr key={integration.id}>
                        <td>{integration.name}</td>
                        <td>{integration.request_url}</td>
                        <td>{integration.image_url}</td>
                        <td>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => onEdit(integration)}
                            >
                                Edit
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default IntegrationList;